import { useEffect } from 'react';
import { components, ControlProps } from 'react-select';
import { InputLabel, ReactSelectStyled } from './styles';

export interface ReactSelectFloraProps {
  type?: string;
  options: any;
  value?: any;
  defaultValue?: any;
  onChangeSelect?: any;
  label: string;
  required?: boolean;
  id?: string;
  hasError?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
}

interface ControlCompProps extends ControlProps {
  isFocused: boolean;
  hasValue: boolean;
  label: string;
  required?: boolean;
}

const ControlComp = ({
  isFocused,
  hasValue,
  label,
  required,
  ...rest
}: ControlCompProps) => {
  return (
    <>
      <InputLabel
        isFloating={isFocused || hasValue}
        isFocused={isFocused}
        hasValue={hasValue}
      >
        {label}
        <span>{required ? '*' : ''}</span>
      </InputLabel>
      <components.Control isFocused={isFocused} hasValue={hasValue} {...rest} />
    </>
  );
};

const CustomControl = (props: ControlCompProps) => <ControlComp {...props} />;

export const ReactSelectFlora = ({
  type,
  options,
  value,
  defaultValue,
  onChangeSelect,
  label,
  required,
  id,
  hasError = false,
  disabled = false,
  isLoading = false,
}: ReactSelectFloraProps) => {
  useEffect(() => {}, [disabled]);

  return (
    <ReactSelectStyled
      components={{
        Control: CustomControl,
      }}
      options={options}
      placeholder=""
      noOptionsMessage={() => 'Carregando...'}
      value={value}
      defaultValue={defaultValue}
      onChange={e => (type ? onChangeSelect(type, e) : onChangeSelect(e))}
      id={id}
      hasError={hasError}
      isDisabled={disabled}
      isLoading={isLoading}
    />
  );
};
